// extracted by mini-css-extract-plugin
module.exports = {"link":"RouterLink_link__1UkYJ"};